define('modules/overview/overview_collection',[
  'backbone',
  'jquery',
  '_',
  'modules/player/player_model',

  'session',
], function (Backbone, $, _, PlayerModel, session) {
  'use strict';
  var Collection = Backbone.Collection.extend({
    model: PlayerModel,
    metadata: {},
    params: {
      search: null,
      order_by: 'title',
      order: 'ASC',
    },
    parse: function (response) {
      var players = [];
      _.forEach(
        response.data,
        function (zone) {
          _.forEach(
            zone.players,
            function (player) {
              _.extend(player, {
                id: player.id + '_' + zone.zone_id,
                player_id: player.id,
                zone_id: zone.zone_id,
                zone_title: zone.zone_title,
              });

              player.preview = session.get('apiBaseUrl') + '/' + player.preview;
              player.capacity = player.capacity || null;
              if (player.capacity) {
                var secondsLeft =
                  player.capacity.max_looplength -
                  player.capacity.current_looplength;
                player.capacity.seconds_left = Math.max(0, secondsLeft);
              }
              players.push(player);
            },
            this
          );
        },
        this
      );

      if (response.metadata) {
        this.metadata = _.extend(response.metadata);
        this.params = _.extend(response.metadata);
      }
      return players;
    },
    url: function () {
      return (
        session.get('apiUrl') +
        'locations/' +
        this.params.location_id +
        '/players'
      );
    },
  });

  return new Collection();
});

